module.exports = __webpack_public_path__ + "img/chatt-valley.3248551a.jpg";